export const unknownString = 'unknown';
//# sourceMappingURL=consts.js.map